const BoxTitle = ({ title, extraClasses }) => (
	<h3 className={`font-bold line-clamp-2 leading-5 ${extraClasses}`}>
		{title}
	</h3>
);

export default BoxTitle;
